"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaysteCustomerDocumentQuery = exports.WaysteDashboardCustomerDocumentSigned = exports.WaysteCustomerDocumentUpdate = exports.WaysteCustomerDocumentCreate = exports.WaysteCustomerDocumentTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
exports.WaysteCustomerDocumentTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    customerID: typebox_1.Type.String({ format: 'uuid' }),
    s3ItemRef: common_1.S3ItemReference,
    signableDocumentID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    signedName: typebox_1.Type.Optional(typebox_1.Type.String()),
    signedAt: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    expired: typebox_1.Type.Boolean(),
    metadata: common_1.MetaData,
});
exports.WaysteCustomerDocumentCreate = typebox_1.Type.Union([
    typebox_1.Type.Object({
        type: typebox_1.Type.Literal('SIGNABLE_DOCUMENT'),
        customerID: typebox_1.Type.String({ format: 'uuid' }),
        signableDocumentID: typebox_1.Type.String({ format: 'uuid' }),
    }),
    typebox_1.Type.Object({
        type: typebox_1.Type.Literal('REGULAR_DOCUMENT'),
        customerID: typebox_1.Type.String({ format: 'uuid' }),
        s3ItemRef: common_1.S3ItemReference,
    }),
]);
exports.WaysteCustomerDocumentUpdate = typebox_1.Type.Partial(typebox_1.Type.Object({
    expired: typebox_1.Type.Boolean(),
}));
exports.WaysteDashboardCustomerDocumentSigned = typebox_1.Type.Object({
    signedName: typebox_1.Type.String(),
    s3ItemRef: typebox_1.Type.Optional(common_1.S3ItemReference),
});
exports.WaysteCustomerDocumentQuery = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    common_1.BaseQuery,
    typebox_1.Type.Object({
        isSigned: typebox_1.Type.Boolean(),
        isActive: typebox_1.Type.Boolean(),
        customerID: typebox_1.Type.String(), // Comma separated list of customer ids
    }),
]));
//# sourceMappingURL=wayste-customer-document-transport.js.map